import type { ReactNode } from 'react';
import { useState, useMemo, createContext, useContext } from 'react';

interface BottomMenuContextValue {
  anchorData: { id: string; el: HTMLElement } | null;
  setAnchorData: (data: { id: string; el: HTMLElement } | null) => void;
}

const BottomMenuContext = createContext<BottomMenuContextValue>({
  anchorData: null,
  setAnchorData: () => {},
});

export function useBottomMenuClose() {
  const { setAnchorData } = useContext(BottomMenuContext);
  return () => setAnchorData(null);
}

export function useBottomMenuContext() {
  return useContext(BottomMenuContext);
}

export function BottomMenuProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  const [anchorData, setAnchorData] = useState<{
    id: string;
    el: HTMLElement;
  } | null>(null);

  const value = useMemo(() => ({ anchorData, setAnchorData }), [anchorData]);

  return (
    <BottomMenuContext.Provider value={value}>
      {children}
    </BottomMenuContext.Provider>
  );
}
